export function validateValue<T>(value: unknown, validValues: readonly T[], defaultValue: T): T {
  if (validValues.includes(value as T)) {
    return value as T;
  }
  return defaultValue;
}
